import {Tickets} from '../../../assets/icons/Tickets';
import {CheckMarkCircle} from '../../../assets/icons/CheckMarkCircle';
import {EmailCheck} from '../../../assets/icons/EmailCheck';
import {SmsMessage} from '../../../assets/icons/SmsMessage';
import {MessageTypeConfig} from './types';
import EmailScreen from '../emailScreen/EmailScreen';
import SmsScreen from '../smsScreen/SmsScreen';
import PreviewScreen from '../previewScreen/PreviewScreen';
import WhatsAppScreen from '../whatsAppScreen/WhatsAppScreen';
import WhatsAppPreview from '../whatsAppScreen/whatsAppPreview/WhatsAppPreview';
import EmailScreenPreview from '../emailScreenPreview/EmailScreenPreview';
import ArrivalConfirmationScreen from '../suspendedScreen/ArrivalConfirmationScreen';
import SuspendedScreen from '../suspendedScreen/SuspendedScreen';
import UnauthorizedWhatsApp from '../unauthorizedWhatsApp/UnauthorizedWhatsApp';
import {IS_NEW_TEMPLATE} from '../../../config/config';
import {isBillingAccount} from '../../../functions/customSystemPixel/customSystemPixel';

export const MESSAGE_TYPES = {
    sendTicket: 'sendTicket',
    orderConfirmation: 'orderConfirmation',
    arrivalConfirmation: 'arrivalConfirmation',
    desperate: 'desperate',
    billing: 'billing'
} as const;
export const DELIVERY_TYPES = {
    email: 'email',
    sms: 'sms',
    whatsapp: 'whatsapp'
} as const;
export const messageTypeConfig: Record<typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES], MessageTypeConfig> = {
    [MESSAGE_TYPES.sendTicket]: {
        icon: <Tickets />,
        checkAccess: ()=> true,
        allowedDeliveryTypes: ['email', 'sms', 'whatsapp']
    },
    [MESSAGE_TYPES.orderConfirmation]:{
        icon: <EmailCheck />,
        checkAccess: ({susStatus, suspendedStatus})=> susStatus && suspendedStatus===1,
        allowedDeliveryTypes: ['email', 'sms']
    },
    [MESSAGE_TYPES.arrivalConfirmation]:{
        icon: <CheckMarkCircle />,
        checkAccess: ({susStatus, confirmationStatus, customerConfirmation})=> susStatus && confirmationStatus===1 && customerConfirmation,
        allowedDeliveryTypes: ['email', 'sms']
    },
    [MESSAGE_TYPES.desperate]: {
        icon: <EmailCheck />, 
        checkAccess: ()=> true, 
        allowedDeliveryTypes: ['email', 'sms']
    },
    [MESSAGE_TYPES.billing]: {
        icon: <EmailCheck />, 
        checkAccess: ({hasBillings, pid})=> !!hasBillings && isBillingAccount(pid), 
        allowedDeliveryTypes: ['email', 'sms']
    }
};

export const deliveryTypeIcons: { [key: string]: string |  JSX.Element} = {
    'whatsapp': 'whatsApp',
    'email': 'mail',
    'sms': <SmsMessage />
} as const;

export const createScreensTypes = (eventWhatsAppStatus: boolean, accountPackagesProducer: any) => ({
    email: {
        Comps:{
            sendTicket: ()=><EmailScreen type={'ticket'} />,
            arrivalConfirmation: ArrivalConfirmationScreen,
            orderConfirmation: SuspendedScreen,
            desperate:  ()=><EmailScreen type={'desperate'} />,
            billing:  ()=><EmailScreen type={'billing'} />,

        },
        CompPreview: {
            sendTicket:EmailScreenPreview,
            arrivalConfirmation:() => <></>,
            orderConfirmation:  () => <></>,
            desperate:  EmailScreenPreview,
            billing:  EmailScreenPreview
        },
        CompPreviewProps:{brandingPreview: accountPackagesProducer?.brandingSms}
    },
    sms: {
        Comps:{
            sendTicket: SmsScreen,
            arrivalConfirmation: ArrivalConfirmationScreen,
            orderConfirmation: SuspendedScreen,
            desperate: SmsScreen,
            billing: SmsScreen
        },
        CompPreview: PreviewScreen,
        CompPreviewProps:{brandingPreview: accountPackagesProducer?.brandingSms}
    },
    whatsapp: {
        Comps: {
            sendTicket: eventWhatsAppStatus ? WhatsAppScreen : UnauthorizedWhatsApp,
            arrivalConfirmation: ArrivalConfirmationScreen,
            orderConfirmation: SuspendedScreen,
            desperate: eventWhatsAppStatus ? WhatsAppScreen : UnauthorizedWhatsApp,
            billing: eventWhatsAppStatus ? WhatsAppScreen : UnauthorizedWhatsApp
        },
        CompPreview: eventWhatsAppStatus ? WhatsAppPreview : null,
        CompPreviewProps: {
            brandingPreview: accountPackagesProducer?.brandingSms,
            whatsappTemplate: getWhatsappTemplateName
        }
    }
}); 

//TEMP: tamplate name sould come from backend
export const getWhatsappTemplateName = (messageType, eventType, eventId) => {
    const isNewService = IS_NEW_TEMPLATE(Number(eventId));
    if(!isNewService) return null;
    if(eventType === 'givechak') return 'givechak';
    if(messageType === 'desperate') return 'desperate';
    if(messageType === 'billing') return 'billing';
    return 'sendingTicket';
};